export const ADAPTER_SETUP_PROGRESS_KEY = "setupProgress";
